import React from 'react';

const Footer = () => {
  return (
    <footer className="footer mt-auto bg-white">
      <div className="container text-center mx-auto" style={{ maxWidth: '1200px' }}>
      <span style={{ color: '#171717', fontSize: "12px" }}>
  Desenvolvido e suportado por{' '}  
  <a 
  className="fw-bold"
    href="https://www.codeplusmore.com" 
    target="_blank" 
    rel="noopener noreferrer" 
    style={{ color: 'inherit', textDecoration: 'none' }}
  >
     CodePlusMore
  </a>
  </span>
      </div>
    </footer>
  );
};

export default Footer;
